<template>
  <div>
    <span class="date">{{ data.createTime }}</span>
    <div class="item">
      <div class="first">
        <span>
          <img draggable="false" src="/static/img/location.png" alt="" />
          <el-tooltip
            :disabled="data.site.length <= 13"
            effect="dark"
            :content="data.site"
            placement="top"
          >
            <span>{{ data.site }}</span>
          </el-tooltip>
        </span>
      </div>
      <div class="second">
        <el-tooltip
          :disabled="`${data.faultLevel}-${data.faultInfo}`.length <= 16"
          effect="dark"
          :content="`${data.faultLevel}-${data.faultInfo}`"
          placement="top"
        >
          <span class="info"
            ><span :style="`color: ${levelColor}`">{{ data.faultLevel }}</span
            >-{{ data.faultInfo }}</span
          >
        </el-tooltip>
      </div>
      <div class="third">
        <span>{{ `${data.productName} ${data.projectName}` }}</span>
      </div>
      <div>
        <img style="width: 100%;" src="/static/img/line.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { levelColors } from "@/config/color";
export default {
  name: "",
  props: {
    data: {
      type: Object,
      defalut: () => ({})
    }
  },

  data() {
    return {
      isRead: false,
      date: "",
      time: "",
    };
  },

  methods: {
  },

  computed: {
    levelColor: function() {
      let item = levelColors.find(e => e.level === this.data.faultLevel);
      return item ? item.color : "#fff";
    }
  },

  mounted() {
    let d = this.data.createTime.split(" ");
    this.date = d[0];
    this.time = d[1];
  }
};
</script>
<style scoped lang="less">
.date {
  display: inline-block;
  font-size: 16px;
  margin-left: 20px;
  color: #fff;
}
.item {
  position: relative;
  user-select: none;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 4px;
  opacity: 0.7;
  height: 105px;
  margin-bottom: 20px;
  > div {
    margin: 0 20px;
    padding: 5px 0;
    padding-left: 5px;
  }
  .first {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 14px;
    > span:nth-child(1) {
      letter-spacing: 1px;
      color: #d4dbde;
      img {
        vertical-align: bottom;
        margin-right: 6px;
      }
      display: inline-block;
      width: 60%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    > span:nth-child(2) {
      float: right;
      line-height: 16px;
      letter-spacing: 0px;
      color: #1d6a74;
      span:first-child {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }
  .second {
    > span:nth-child(1) {
      display: inline-block;
      font-size: 15px;
      font-style: italic;
      font-weight: 550;
      line-height: 16px;
      letter-spacing: 2px;
      color: #d4dade;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    > span:nth-child(2) {
      display: inline-block;
      float: right;
      width: 66px;
      height: 24px;
      line-height: 22px;
      text-align: center;
      border-radius: 12px;
      font-size: 14px;
      font-style: italic;
      letter-spacing: 1px;
    }
  }
  .third {
    span {
      display: inline-block;
      width: 100%;
      font-size: 14px;
      letter-spacing: 1px;
      color: #d4dbde;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .border {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .read {
    border: solid 1px #1d6a74;
    color: #1d6a74;
  }
  .unread {
    border: solid 1px #f5b000;
    color: #f5b000;
    cursor: pointer;
  }
}
</style>
